import React, { useState } from 'react';

const AccountingFAQ = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const faqData = [
        {
            question: "What are the golden rules of accounting?",
            answer: (
                <>
                    <p>The three golden rules of accounting are:</p>
                    <ol>
                        <li><strong>Personal Account:</strong> Debit the receiver, credit the giver</li>
                        <li><strong>Real Account:</strong> Debit what comes in, credit what goes out</li>
                        <li><strong>Nominal Account:</strong> Debit all expenses and losses, credit all incomes and gains</li>
                    </ol>
                </>
            )
        },
        {
            question: "What is a journal in accounting?",
            answer: (
                <>
                    <p>A journal is the first book of original entry where all transactions are recorded in chronological order before they are posted to ledger accounts. Each entry in the journal is called a journal entry and includes:</p>
                    <ul>
                        <li>Date of transaction</li>
                        <li>Accounts affected (with debit and credit amounts)</li>
                        <li>Brief description (narration)</li>
                        <li>Reference number</li>
                    </ul>
                </>
            )
        },
        {
            question: "What is a trial balance and why is it important?",
            answer: (
                <>
                    <p>A trial balance is a statement that lists all the ledger accounts and their balances (debit or credit) at a particular date. It serves two main purposes:</p>
                    <ol>
                        <li>To check the arithmetic accuracy of ledger accounts (total debits should equal total credits)</li>
                        <li>To serve as a starting point for preparing financial statements</li>
                    </ol>
                    <p>However, a balanced trial balance doesn't guarantee there are no errors in the accounting records.</p>
                </>
            )
        },
        {
            question: "How do I create a company in Tally Prime?",
            answer: (
                <>
                    <p>To create a company in Tally Prime:</p>
                    <ol>
                        <li>Open Tally Prime and from the Gateway of Tally screen, press Alt+F3 or click on 'Create Company'</li>
                        <li>Fill in the company details (name, address, financial year, etc.)</li>
                        <li>Select the appropriate country, currency, and PIN code</li>
                        <li>Choose the correct accounting and inventory features based on your requirements</li>
                        <li>Set the company's books beginning from date</li>
                        <li>Save the company by pressing Ctrl+A</li>
                    </ol>
                </>
            )
        },
        {
            question: "What are the common components of salary structure?",
            answer: (
                <>
                    <p>A typical salary structure includes:</p>
                    <div style={{
                        overflowX: 'auto',
                        margin: '15px 0'
                    }}>
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            margin: '10px 0',
                            border: '1px solid #dadce0'
                        }}>
                            <thead>
                                <tr>
                                    <th style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        backgroundColor: '#f1f3f4',
                                        border: '1px solid #dadce0'
                                    }}>Component</th>
                                    <th style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        backgroundColor: '#f1f3f4',
                                        border: '1px solid #dadce0'
                                    }}>Description</th>
                                    <th style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        backgroundColor: '#f1f3f4',
                                        border: '1px solid #dadce0'
                                    }}>Tax Treatment</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Basic Salary</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Core salary (usually 40-50% of CTC)</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Fully taxable</td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>HRA (House Rent Allowance)</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>For rented accommodation</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Partially exempt with conditions</td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>DA (Dearness Allowance)</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Cost of living adjustment</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Fully taxable</td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Special Allowances</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Transport, medical, etc.</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Varies by allowance type</td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>PF (Provident Fund)</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>12% of basic+DA (employee contribution)</td>
                                    <td style={{
                                        padding: '12px',
                                        textAlign: 'left',
                                        border: '1px solid #dadce0'
                                    }}>Tax-exempt with limits</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            )
        },
        {
            question: "What is the EPF registration process?",
            answer: (
                <>
                    <p>The EPF registration process involves:</p>
                    <ol>
                        <li>Obtain a Digital Signature Certificate (DSC) for the employer</li>
                        <li>Register on the EPFO portal (www.epfindia.gov.in)</li>
                        <li>Fill Form 5A (for establishment details) and Form 11 (for employee details)</li>
                        <li>Submit required documents (PAN, incorporation certificate, address proof, etc.)</li>
                        <li>Make initial contribution after receiving establishment code</li>
                        <li>Obtain PF code, establishment number, and password</li>
                    </ol>
                    <p>The entire process is now done online through the Unified Portal.</p>
                </>
            )
        },
        {
            question: "What are the most useful Excel formulas for accounting?",
            answer: (
                <>
                    <p>Essential Excel formulas for accounting include:</p>
                    <ul>
                        <li><strong>SUM/SUMIF/SUMIFS:</strong> For totaling values with optional conditions</li>
                        <li><strong>VLOOKUP/XLOOKUP:</strong> For finding data in tables (e.g., product prices)</li>
                        <li><strong>IF/IFS:</strong> For conditional calculations (e.g., tax brackets)</li>
                        <li><strong>PMT/PPMT/IPMT:</strong> For loan calculations</li>
                        <li><strong>INDEX-MATCH:</strong> More flexible alternative to VLOOKUP</li>
                        <li><strong>SUBTOTAL:</strong> For filtered data calculations</li>
                        <li><strong>ROUND/ROUNDUP/ROUNDDOWN:</strong> For financial rounding</li>
                        <li><strong>EOMONTH:</strong> For end-of-month calculations</li>
                    </ul>
                </>
            )
        }
    ];

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div style={{
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            lineHeight: 1.6,
            color: '#202124',
            //   backgroundColor: '#f8f9fa',
            padding: '20px',
            maxWidth: '1200px',
            margin: '0 auto'
        }}>
            <p style={{
                color: 'blue',
                textAlign: 'center',
                fontSize:"35px",
                fontWeight:"bold",
                marginBottom: '30px'
            }}>
                Accounting <span style={{ color: 'orange' }}>Overview</span>
            </p>


            <div style={{
                backgroundColor: '#fff',
                borderRadius: '8px',
                boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                overflow: 'hidden'
            }}>
                {faqData.map((item, index) => (
                    <div
                        key={index}
                        style={{
                            borderBottom: '1px solid #dadce0'
                        }}
                    >
                        <div
                            style={{
                                padding: '16px 24px',
                                cursor: 'pointer',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                fontWeight: 500,
                                fontSize: '18px',
                                transition: 'background-color 0.2s',
                                backgroundColor: activeIndex === index ? '#f1f3f4' : 'transparent'
                            }}
                            onClick={() => toggleFAQ(index)}
                        >
                            {item.question}
                            <span style={{
                                fontSize: '24px',
                                color: '#4285f4',
                                transition: 'transform 0.3s'
                            }}>{activeIndex === index ? '-' : '+'}</span>
                        </div>
                        <div style={{
                            padding: activeIndex === index ? '0 24px 20px' : '0 24px',
                            maxHeight: activeIndex === index ? '1000px' : '0',
                            overflow: 'hidden',
                            transition: 'max-height 0.3s ease-out, padding 0.3s ease'
                        }}>
                            <div style={{ paddingTop: '8px' }}>
                                {item.answer}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AccountingFAQ;